RemoteDesktopSession = require('./session')
class RemoteDesktopDirective
  @$inject: ["socket", "$timeout"]  
  constructor: (socket,$timeout)->
    class RemoteDesktop
      restrict: "C"
      template: require("./remote-desktop.pug")
      scope:
        device: "="
        ratio: "="
        disconnect: "="
      link: (scope, element, attrs)->
        # element.html '<video tabindex="1"/><div class="loading"><i class="fa fa-spinner fa-spin"></div>'
        screen = element.find("video")
        watching = scope.$watch "device", (val)->          
          screen.attr "loading", true
          if val
            session = new RemoteDesktopSession(screen, socket, val, scope.disconnect, $timeout);
            watching()
        scope.$watch "ratio", (val)->
          scope.disconnect = false
          if scope.device
            scope.device.resize = val
            session = new RemoteDesktopSession(screen, socket, scope.device, scope.disconnect, $timeout);
        return
        


    return new RemoteDesktop();


module.exports = RemoteDesktopDirective


// WEBPACK FOOTER //
// ./src/component/device/remote/directive/index.coffee